import React from 'react';
import { string, func, bool, object} from 'prop-types';
import { withNamespaces } from 'react-i18next';
import '../../../i18n';
import {QuizSentence} from '../QuizSentence/index';
import {InfoTooltip} from '../../molecules/Tooltip';
import IconButton from '../../atoms/IconButton';
import style from './style';

function QuizListItem({content, index, indexed, options, isSample=false, onClick, onCheck, onDelete, checked,t, ...props}) {
	return(
		<style.Li {...props}>
			{indexed && (
				<style.Index>
					{( '00' + index ).slice( -2 )}
				</style.Index>
			)}
			
			{isSample? <style.SampleIcon>Sample</style.SampleIcon>:
				<style.Checkbox key={checked} onCheck={onCheck} checked={checked}/>}
			<style.UnderlinedList onClick={onClick} checked={checked}>
				<QuizSentence 
					content={content}
					showNumber={false}
					options={options}
					blankColor={'transparent'}
				/>
			</style.UnderlinedList>
			<style.TrashIconWrapper>
				<InfoTooltip text={t('create-quiz.DeleteQuiz')}>
					<IconButton onClick={onDelete}> 
						<style.TrashIcon/>
					</IconButton>
				</InfoTooltip>
			</style.TrashIconWrapper>
		</style.Li>
	);
}
QuizListItem.propTypes = {
	content:string.isRequired,
	onClick:func.isRequired,
	isSample:bool,
	onCheck:func,
	onDelete:func,
	options:object,
	checked:bool,
	className:string
};

export default withNamespaces()(QuizListItem);
